import React from 'react';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, ResponsiveContainer, Text } from 'recharts';

const SkillRadarChart = ({ skills }) => {
  const chartData = skills?.map(skill => ({
    skill: skill?.name,
    value: skill?.current,
    fullMark: 100
  }));

  const renderCustomTick = ({ x, y, payload }) => {
    const skill = skills.find(s => s.name === payload.value);
    const value = skill ? skill.current : 0;
    
    return (
      <g transform={`translate(${x},${y})`}>
        <text 
            textAnchor="middle" 
            dominantBaseline="middle" 
            className="fill-slate-900 font-bold text-[10px]"
        >
          {payload.value}
        </text>
        <text 
            dy={12} 
            textAnchor="middle" 
            dominantBaseline="middle" 
            className="fill-slate-400 font-black text-[10px]"
        >
          {value}%
        </text>
      </g>
    );
  };

  return (
    <div className="w-full h-[300px]">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart cx="50%" cy="50%" outerRadius="75%" data={chartData}>
          <PolarGrid stroke="#94A3B8" strokeOpacity={0.65} />
          <PolarAngleAxis 
            dataKey="skill" 
            tick={renderCustomTick}
          />
          <Radar
            name="Skills"
            dataKey="value"
            stroke="#10E58F"
            strokeWidth={2}
            fill="#10E58F"
            fillOpacity={0.25}
            dot={{ r: 3, fill: '#10E58F' }}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SkillRadarChart;